import { render, staticRenderFns } from "./CotizacionMovilComponent.vue?vue&type=template&id=288bfd50&scoped=true&"
import script from "./CotizacionMovilComponent.vue?vue&type=script&lang=js&"
export * from "./CotizacionMovilComponent.vue?vue&type=script&lang=js&"
import style0 from "./CotizacionMovilComponent.vue?vue&type=style&index=0&id=288bfd50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288bfd50",
  null
  
)

export default component.exports